import styles from "./ALumniPaymentFailed.module.css";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import Loader from "../Loader/Loader";
import {
  createDonationPaymentData,
  submitDonationPayment,
} from "@/services/DonationPaymentService";

const ALumniPaymentFailed = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [donationDetails, setDonationDetails] = useState<{
    amount: number;
    email: string;
    name: string;
  } | null>(null);

  useEffect(() => {
    const storedDetails = localStorage.getItem("donationDetails");
    if (storedDetails) {
      setDonationDetails(JSON.parse(storedDetails));
    }
  }, []);

  const handleRetry = async () => {
    if (!donationDetails) {
      console.error("No donation details found");
      return;
    }

    setIsLoading(true);
    try {
      const paymentData = await createDonationPaymentData(
        donationDetails.amount,
        donationDetails.email,
        donationDetails.name
      );

      await submitDonationPayment(paymentData);
    } catch (error) {
      console.error("Error retrying payment:", error);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles.PaymentSuccessPage}>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.iconWrapper}>
            <span className={styles.checkIcon}>
              <Image
                src="/assets/payment.png"
                alt="payment"
                title="payment"
                className={styles.logo}
                width={64}
                height={64}
              />
            </span>
          </div>
          <h1 className={styles.title}>Payment Session Expired!</h1>
          <p className={styles.subtitle}>
            It seems like your payment session has timed out. Please restart the
            payment process to secure your application. If you face any issues,
            feel free to contact our support team at [support contact/email].
          </p>

          <div>
            <button className={styles.paymentRetryButton} onClick={handleRetry}>
              Retry Payment
            </button>
            <p>
              Need help? Contact us at [
              <Link href="mailto:support@regenesys.com">
                support@regenesys.com
              </Link>
              ]
            </p>

            {/* <button
              className={styles.homeButton}
              onClick={handleRetry}
              disabled={isLoading}
            >
              Retry Payment
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ALumniPaymentFailed;
